import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface AdminLoadErrorProps {
  /** Human-readable description of what failed to load, e.g. "bug reports". */
  what: string;
  /** Re-run the failed fetch. */
  onRetry: () => void;
}

/**
 * Inline error state for the admin support list pages. Distinct from the empty
 * state on purpose — a failed fetch must never look like "none found", which
 * historically masked the slow Builder Reports query as "no reports".
 */
export function AdminLoadError({ what, onRetry }: AdminLoadErrorProps) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-md border border-destructive/30 bg-destructive/5 px-4 py-8 text-center">
      <AlertTriangle className="h-6 w-6 text-destructive" />
      <div>
        <p className="text-sm font-medium text-destructive">Couldn’t load {what}</p>
        <p className="text-xs text-muted-foreground">
          Something went wrong fetching this list. This is not the same as having none.
        </p>
      </div>
      <Button variant="outline" size="sm" onClick={onRetry}>
        <RefreshCw className="mr-2 h-3.5 w-3.5" />
        Retry
      </Button>
    </div>
  );
}
